import { Theme } from '@raydiant/api-client-js';
import ThemeShareV2 from './ThemeShare/ThemeShareV2';

export interface ThemeSharingModalProps {
  theme?: Theme;
  onClose: () => void;
}

const ThemeSharingModal = ({ theme, onClose }: ThemeSharingModalProps) => {
  return <>{theme && <ThemeShareV2 theme={theme} onClose={onClose} />}</>;
};

export default ThemeSharingModal;
